export const splitTitle = string => {
  if (!string) {
    return ''
  }
  const stringWithFirstLetterUppercase =
    string[0].toUpperCase() + string.slice(1)

  const splitArray = stringWithFirstLetterUppercase.split(/(?=[A-Z])/)

  return splitArray.join(' ')
}



// WEBPACK FOOTER //
// ./src/Components/FilterAndPaginationComponent/utils.js